export default defineNuxtRouteMiddleware((_, from) => {
  const mainStore = useMainStore();
  mainStore.lastRoutePath = from.path;
});
